<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Control de efectivo</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Recorridos</span>
      <span> /</span>
      <span>Control de efectivo</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="filtros-body">
      <!-- Datos declarante -->
      <div
        class="row filtros-header"
        style="
          border-bottom: 1px solid #dee2e6;
          justify-content: start;
          align-items: center;
        "
      >
        <div class="col">
          <h4>
            Datos Declarante
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="declaranteRut"
              class="form-control"
              placeholder="99.999.999-9"
              required
              #declaranteRut
            />
            <label for="declaranteRut">RUT</label>
          </div>
        </div>
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="declaranteNombre"
              class="form-control"
              placeholder="Nombre"
              required
              #declaranteNombre
            />
            <label for="declaranteNombre">Nombre</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <!-- Declaración de pagos -->
          <div
            class="row filtros-header pl-0"
            style="
              border-bottom: 1px solid #dee2e6;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="col">
              <h4>
                Declaración de pagos
              </h4>
            </div>
            <div class="col text-right">
              <h4>Total = <strong>$ 0</strong></h4>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="pagoEfectivo"
                  class="form-control"
                  placeholder="$"
                  required
                  #pagoEfectivo
                />
                <label for="pagoEfectivo">Efectivo</label>
              </div>
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="pagoDctoTransferencia"
                  class="form-control"
                  placeholder="$"
                  required
                  #pagoDctoTransferencia
                />
                <label for="pagoDctoTransferencia">Dcto./Transferencia</label>
              </div>
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="pagoDeposito"
                  class="form-control"
                  placeholder="$"
                  required
                  #pagoDeposito
                />
                <label for="pagoDeposito">Deposito</label>
              </div>
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="pagoCheque"
                  class="form-control"
                  placeholder="$"
                  required
                  #pagoCheque
                />
                <label for="pagoCheque">Cheque</label>
              </div>
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="pagoDiferencial"
                  class="form-control"
                  placeholder="$"
                  required
                  #pagoDiferencial
                />
                <label for="pagoDiferencial">Diferencial</label>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <!-- Declaración dinero recibido -->
          <div
            class="row filtros-header pl-0"
            style="
              border-bottom: 1px solid #dee2e6;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="col">
              <h4>
                Declaración dinero recibido
              </h4>
            </div>
            <div class="col text-right">
              <h4>Total = <strong>$ 0</strong></h4>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="recibidoEfectivo"
                  class="form-control"
                  placeholder="$"
                  required
                  #recibidoEfectivo
                />
                <label for="recibidoEfectivo">Efectivo</label>
              </div>
              <div class="md-form" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="recibidoDctoTransferencia"
                  class="form-control"
                  placeholder="$"
                  required
                  #recibidoDctoTransferencia
                />
                <label for="recibidoDctoTransferencia"
                  >Dcto./Transferencia</label
                >
              </div>
              <div class="md-form mb-3" style="max-width: 250px;">
                <input
                  value=""
                  type="text"
                  id="recibidoCheque"
                  class="form-control"
                  placeholder="$"
                  required
                  #recibidoCheque
                />
                <label for="recibidoCheque">Cheque</label>
              </div>
            </div>
          </div>
          <div
            class="row filtros-header"
            style="justify-content: start; align-items: center;"
          >
            <div class="col pl-0">
              <h5>
                Depósitos
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col" style="max-width: 250px;">
              <div class="md-form">
                <input
                  value=""
                  type="text"
                  id="recibidoDeposito"
                  class="form-control"
                  placeholder="$"
                  required
                  #recibidoDeposito
                />
                <label for="recibidoDeposito">Monto</label>
              </div>
            </div>
            <div class="col" style="max-width: 250px;">
              <div class="md-form">
                <input
                  value=""
                  type="text"
                  id="recibidoNroDeposito"
                  class="form-control"
                  placeholder="#"
                  required
                  #recibidoNroDeposito
                />
                <label for="recibidoNroDeposito">Nro. Depósito</label>
              </div>
            </div>
            <div class="col">
              <button
                mdbBtn
                type="button"
                color="secondary"
                mdbWavesEffect
                class="btn"
              >
                Agregar
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="table-responsive">
                <table
                  class="table table-striped table-hover table-sm align-middle"
                >
                  <thead class="grey lighten-2">
                    <tr>
                      <th scope="col">Nro. Depósito</th>
                      <th scope="col">Monto</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>12312312313</td>
                      <td>$ 3.000</td>
                      <td>
                        <button
                          mdbBtn
                          type="button"
                          size="sm"
                          color="primary"
                          mdbWavesEffect
                          class="btn-actions-sm"
                        >
                          <mdb-icon fas icon="trash"></mdb-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>12312312313</td>
                      <td>$ 3.000</td>
                      <td>
                        <button
                          mdbBtn
                          type="button"
                          size="sm"
                          color="primary"
                          mdbWavesEffect
                          class="btn-actions-sm"
                        >
                          <mdb-icon fas icon="trash"></mdb-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot class="grey lighten-4">
                    <tr>
                      <th scope="col"></th>
                      <th scope="col" class="text-right">Total</th>
                      <th scope="col">$ 6.000</th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row filtros-header"
        style="
          border-bottom: 1px solid #dee2e6;
          justify-content: start;
          align-items: center;
        "
      >
        <div class="col">
          <h4>
            Diferencial
          </h4>
        </div>
      </div>

      <div class="row pt-3 pb-1 pl-0">
        <div class="col" style="max-width: 170px;">
          <h5>Tipo de abono:</h5>
        </div>
        <div
          class="col dato"
          style="min-width: 350px; display: flex; align-items: center;"
        >
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline" style="margin-right: 20px;">
            <input
              type="radio"
              class="form-check-input"
              id="materialInline1"
              name="inlineMaterialRadiosExample"
              mdbInput
            />
            <label class="form-check-label" for="materialInline1">Afecta</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="materialInline2"
              name="inlineMaterialRadiosExample"
              mdbInput
            />
            <label class="form-check-label" for="materialInline2">Exenta</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="diferencialMonto"
              class="form-control"
              placeholder="$"
              required
              #diferencialMonto
            />
            <label for="diferencialMonto">Monto</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="diferencialMotivo"
              class="form-control"
              placeholder="EscribeMotivo"
              required
              #diferencialMotivo
            />
            <label for="diferencialMotivo">Motivo</label>
          </div>
        </div>
      </div>

      <div
        class="row filtros-header"
        style="
          border-bottom: 1px solid #dee2e6;
          justify-content: start;
          align-items: center;
        "
      >
        <div class="col">
          <h4>
            Cargo de ruta
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="cargoRutaMonto"
              class="form-control"
              placeholder="$"
              required
              #cargoRutaMonto
            />
            <label for="cargoRutaMonto">Monto</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="cargoRutaMotivo"
              class="form-control"
              placeholder="EscribeMotivo"
              required
              #cargoRutaMotivo
            />
            <label for="cargoRutaMotivo">Motivo</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Guardar
    </button>
  </div>
</div>
